import { render, staticRenderFns } from "./PGCancelPopup.vue?vue&type=template&id=47c5f9c5&"
import script from "./PGCancelPopup.vue?vue&type=script&lang=js&"
export * from "./PGCancelPopup.vue?vue&type=script&lang=js&"
import style0 from "./PGCancelPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports